import { useStripTags } from './useStripTags'
export function useTextCut(input: string, maxLength = 50): string {
  const plainText = useStripTags(input)
  return plainText.length > maxLength ? plainText.slice(0, maxLength).trimEnd() + '...' : plainText
}
